"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API Documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultApi = exports.DefaultApiFactory = exports.DefaultApiFp = exports.DefaultApiAxiosParamCreator = exports.WorkflowType = exports.WorkflowObjectObjectEnum = exports.VisualizationBlockDataDataPeriodAnyOfIntervalEnum = exports.VisualizationBlockDataDataPeriodIntervalEnum = exports.VisualizationBlockDataDataMetricsInnerOneOf1FormatEnum = exports.VisualizationBlockDataDataMetricsInnerOneOf1KindEnum = exports.VisualizationBlockDataDataMetricsInnerOneOfTypeEnum = exports.VisualizationBlockDataDataMetricsInnerOneOfKindEnum = exports.VisualizationBlockDataDataGranularityEnum = exports.VisualizationBlockDataDataTypeEnum = exports.VisualizationBlockDataTypeEnum = exports.UnknownBlockKindEnum = exports.ThreadObjectObjectEnum = exports.ThreadCreateSurveyPayloadTypeEnum = exports.ThreadCreateInterviewPayloadTypeEnum = exports.ThreadCreateAnalysisPayloadTypeEnum = exports.TextBlockModifiersEnum = exports.TextBlockKindEnum = exports.SelectBlockTypeEnum = exports.SelectBlockKindEnum = exports.SectionBlockKindEnum = exports.RunObjectObjectEnum = exports.PromptObjectObjectEnum = exports.PromptCreateSurveyPayloadTypeEnum = exports.MessageRole = exports.MessageObjectObjectEnum = exports.EventBlockDataOneOfKindEnum = exports.EventBlockKindEnum = exports.CustomBlockKindEnum = exports.ButtonElementVariantEnum = exports.ButtonElementKindEnum = exports.AttachmentReferenceObjectTypeEnum = exports.AttachmentReferenceObjectKindEnum = exports.ActionBlockKindEnum = void 0;
const axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("./common");
// @ts-ignore
const base_1 = require("./base");
exports.ActionBlockKindEnum = {
    Action: 'action'
};
exports.AttachmentReferenceObjectKindEnum = {
    Reference: 'reference'
};
exports.AttachmentReferenceObjectTypeEnum = {
    Submission: 'submission'
};
exports.ButtonElementKindEnum = {
    Button: 'button'
};
exports.ButtonElementVariantEnum = {
    Primary: 'primary',
    Secondary: 'secondary'
};
exports.CustomBlockKindEnum = {
    Custom: 'custom'
};
exports.EventBlockKindEnum = {
    Event: 'event'
};
exports.EventBlockDataOneOfKindEnum = {
    Action: 'action'
};
exports.MessageObjectObjectEnum = {
    Message: 'message'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.MessageRole = {
    User: 'user',
    System: 'system'
};
exports.PromptCreateSurveyPayloadTypeEnum = {
    Survey: 'survey'
};
exports.PromptObjectObjectEnum = {
    Prompt: 'prompt'
};
exports.RunObjectObjectEnum = {
    Run: 'run'
};
exports.SectionBlockKindEnum = {
    Section: 'section'
};
exports.SelectBlockKindEnum = {
    Input: 'input'
};
exports.SelectBlockTypeEnum = {
    Select: 'select'
};
exports.TextBlockKindEnum = {
    Text: 'text'
};
exports.TextBlockModifiersEnum = {
    Bold: 'bold',
    Italic: 'italic',
    Code: 'code',
    Strikethrough: 'strikethrough'
};
exports.ThreadCreateAnalysisPayloadTypeEnum = {
    Analysis: 'analysis'
};
exports.ThreadCreateInterviewPayloadTypeEnum = {
    Interview: 'interview'
};
exports.ThreadCreateSurveyPayloadTypeEnum = {
    Survey: 'survey'
};
exports.ThreadObjectObjectEnum = {
    Thread: 'thread'
};
exports.UnknownBlockKindEnum = {
    Unknown: 'unknown'
};
exports.VisualizationBlockDataTypeEnum = {
    Visualization: 'visualization'
};
exports.VisualizationBlockDataDataTypeEnum = {
    Trend: 'trend',
    Category: 'category'
};
exports.VisualizationBlockDataDataGranularityEnum = {
    Day: 'day',
    Week: 'week',
    Month: 'month',
    Quarter: 'quarter',
    Year: 'year'
};
exports.VisualizationBlockDataDataMetricsInnerOneOfKindEnum = {
    Aggregation: 'aggregation'
};
exports.VisualizationBlockDataDataMetricsInnerOneOfTypeEnum = {
    Sum: 'sum',
    Average: 'average',
    Distribution: 'distribution',
    Count: 'count'
};
exports.VisualizationBlockDataDataMetricsInnerOneOf1KindEnum = {
    Formula: 'formula'
};
exports.VisualizationBlockDataDataMetricsInnerOneOf1FormatEnum = {
    Currency: 'currency',
    Percentage: 'percentage',
    Integer: 'integer',
    Decimal: 'decimal',
    Time: 'time'
};
exports.VisualizationBlockDataDataPeriodIntervalEnum = {
    Day: 'day',
    Week: 'week',
    Month: 'month',
    Quarter: 'quarter',
    Year: 'year',
    Period: 'period'
};
exports.VisualizationBlockDataDataPeriodAnyOfIntervalEnum = {
    Day: 'day',
    Week: 'week',
    Month: 'month',
    Quarter: 'quarter',
    Year: 'year',
    Period: 'period'
};
exports.WorkflowObjectObjectEnum = {
    Workflow: 'workflow'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.WorkflowType = {
    Survey: 'survey',
    Analysis: 'analysis',
    Interview: 'interview'
};
/**
 * DefaultApi - axios parameter creator
 * @export
 */
const DefaultApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary message list
         * @param {string} thread
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messageList: async (thread, options = {}) => {
            // verify required parameter 'thread' is not null or undefined
            (0, common_1.assertParamExists)('messageList', 'thread', thread);
            const localVarPath = `/messages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (thread !== undefined) {
                localVarQueryParameter['thread'] = thread;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary prompt create
         * @param {PromptCreatePayload} [promptCreatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        promptCreate: async (promptCreatePayload, options = {}) => {
            const localVarPath = `/prompts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(promptCreatePayload, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary run create
         * @param {RunCreatePayload} [runCreatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runCreate: async (runCreatePayload, options = {}) => {
            const localVarPath = `/runs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(runCreatePayload, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary thread create
         * @param {ThreadCreatePayload} [threadCreatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        threadCreate: async (threadCreatePayload, options = {}) => {
            const localVarPath = `/threads`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(threadCreatePayload, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary thread retrieve
         * @param {string} threadId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        threadRetrieve: async (threadId, options = {}) => {
            // verify required parameter 'threadId' is not null or undefined
            (0, common_1.assertParamExists)('threadRetrieve', 'threadId', threadId);
            const localVarPath = `/threads/{threadId}`
                .replace(`{${"threadId"}}`, encodeURIComponent(String(threadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary workflow list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workflowList: async (options = {}) => {
            const localVarPath = `/workflows`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary workflow retrieve
         * @param {string} workflowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workflowRetrieve: async (workflowId, options = {}) => {
            // verify required parameter 'workflowId' is not null or undefined
            (0, common_1.assertParamExists)('workflowRetrieve', 'workflowId', workflowId);
            const localVarPath = `/workflows/{workflowId}`
                .replace(`{${"workflowId"}}`, encodeURIComponent(String(workflowId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.DefaultApiAxiosParamCreator = DefaultApiAxiosParamCreator;
/**
 * DefaultApi - functional programming interface
 * @export
 */
const DefaultApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.DefaultApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary message list
         * @param {string} thread
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async messageList(thread, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.messageList(thread, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.messageList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary prompt create
         * @param {PromptCreatePayload} [promptCreatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async promptCreate(promptCreatePayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.promptCreate(promptCreatePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.promptCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary run create
         * @param {RunCreatePayload} [runCreatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async runCreate(runCreatePayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.runCreate(runCreatePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.runCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary thread create
         * @param {ThreadCreatePayload} [threadCreatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async threadCreate(threadCreatePayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.threadCreate(threadCreatePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.threadCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary thread retrieve
         * @param {string} threadId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async threadRetrieve(threadId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.threadRetrieve(threadId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.threadRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary workflow list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workflowList(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workflowList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.workflowList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary workflow retrieve
         * @param {string} workflowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workflowRetrieve(workflowId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workflowRetrieve(workflowId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.workflowRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
exports.DefaultApiFp = DefaultApiFp;
/**
 * DefaultApi - factory interface
 * @export
 */
const DefaultApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.DefaultApiFp)(configuration);
    return {
        /**
         *
         * @summary message list
         * @param {DefaultApiMessageListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messageList(requestParameters, options) {
            return localVarFp.messageList(requestParameters.thread, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary prompt create
         * @param {DefaultApiPromptCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        promptCreate(requestParameters = {}, options) {
            return localVarFp.promptCreate(requestParameters.promptCreatePayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary run create
         * @param {DefaultApiRunCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runCreate(requestParameters = {}, options) {
            return localVarFp.runCreate(requestParameters.runCreatePayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary thread create
         * @param {DefaultApiThreadCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        threadCreate(requestParameters = {}, options) {
            return localVarFp.threadCreate(requestParameters.threadCreatePayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary thread retrieve
         * @param {DefaultApiThreadRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        threadRetrieve(requestParameters, options) {
            return localVarFp.threadRetrieve(requestParameters.threadId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary workflow list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workflowList(options) {
            return localVarFp.workflowList(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary workflow retrieve
         * @param {DefaultApiWorkflowRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workflowRetrieve(requestParameters, options) {
            return localVarFp.workflowRetrieve(requestParameters.workflowId, options).then((request) => request(axios, basePath));
        },
    };
};
exports.DefaultApiFactory = DefaultApiFactory;
/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
class DefaultApi extends base_1.BaseAPI {
    /**
     *
     * @summary message list
     * @param {DefaultApiMessageListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    messageList(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).messageList(requestParameters.thread, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary prompt create
     * @param {DefaultApiPromptCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    promptCreate(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).promptCreate(requestParameters.promptCreatePayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary run create
     * @param {DefaultApiRunCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    runCreate(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).runCreate(requestParameters.runCreatePayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary thread create
     * @param {DefaultApiThreadCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    threadCreate(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).threadCreate(requestParameters.threadCreatePayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary thread retrieve
     * @param {DefaultApiThreadRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    threadRetrieve(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).threadRetrieve(requestParameters.threadId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary workflow list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    workflowList(options) {
        return (0, exports.DefaultApiFp)(this.configuration).workflowList(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary workflow retrieve
     * @param {DefaultApiWorkflowRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    workflowRetrieve(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).workflowRetrieve(requestParameters.workflowId, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.DefaultApi = DefaultApi;
//# sourceMappingURL=api.js.map